import { connect } from 'react-redux';

import { goBack } from '@shared/actions';

import InnerHeader from './InnerHeader';

const mapDispatchToProps = { onClose: goBack };

export default connect(
  null,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...ownProps,
    ...dispatchProps,
    onClose: ownProps.onClose || dispatchProps.onClose,
  }),
)(InnerHeader);
